(function () {
  const SUPABASE_URL = window.CCS_SUPABASE_URL;
  const SUPABASE_KEY = window.CCS_SUPABASE_KEY;
  if (!SUPABASE_URL || !SUPABASE_KEY) return;
  const STORAGE_URL = `${SUPABASE_URL}/storage/v1/object/public/review-photos/`;

  const container = document.getElementById('ccs-reviews');
  if (!container) return;

  const productId = container.dataset.productId;
  const PAGE_SIZE = 15;

  let allReviews = [];
  let filterStar = 0;
  let currentPage = 1;
  let loadFailed = false;
  let selectedRating = 0;

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  async function api(method, path, body) {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      method,
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`,
        'Content-Type': 'application/json',
        'Prefer': method === 'POST' ? 'return=minimal' : 'return=representation'
      },
      body: body ? JSON.stringify(body) : undefined
    });
    if (method === 'GET') return res.json();
    return res;
  }

  async function uploadPhoto(file) {
    const ext = file.name.split('.').pop().replace(/[^a-zA-Z0-9]/g, '') || 'jpg';
    const name = `${productId}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;
    await fetch(`${SUPABASE_URL}/storage/v1/object/review-photos/${name}`, {
      method: 'POST',
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`,
        'Content-Type': file.type
      },
      body: file
    });
    return name;
  }

  function stars(rating) {
    return [1, 2, 3, 4, 5].map((i) =>
      `<span class="ccs-star ${i <= rating ? 'ccs-star--filled' : ''}">★</span>`
    ).join('');
  }

  function renderSummary() {
    const countEl = document.getElementById('ccs-review-count');
    const avgEl = document.getElementById('ccs-avg-score');
    const starsEl = document.getElementById('ccs-avg-stars');
    const distEl = document.getElementById('ccs-distribution');
    const headerEl = document.querySelector('.ccs-reviews__header');

    if (!allReviews.length) {
      if (headerEl) headerEl.classList.add('ccs-reviews__header--empty');
      if (avgEl) avgEl.hidden = true;
      if (starsEl) starsEl.hidden = true;
      if (countEl) countEl.textContent = loadFailed
        ? 'Couldn’t load reviews right now. Please refresh the page.'
        : 'No reviews yet — be the first to share yours.';
      if (distEl) distEl.hidden = true;
      return;
    }

    if (headerEl) headerEl.classList.remove('ccs-reviews__header--empty');
    if (avgEl) avgEl.hidden = false;
    if (starsEl) starsEl.hidden = false;

    const avg = allReviews.reduce((s, r) => s + r.rating, 0) / allReviews.length;
    if (avgEl) avgEl.textContent = avg.toFixed(1);
    if (starsEl) starsEl.innerHTML = stars(Math.round(avg));
    if (countEl) countEl.textContent = `Based on ${allReviews.length} review${allReviews.length !== 1 ? 's' : ''}`;

    const byStar = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    allReviews.forEach((r) => { byStar[r.rating] = (byStar[r.rating] || 0) + 1; });

    if (distEl) {
      distEl.hidden = false;
      distEl.querySelectorAll('.ccs-dist__row').forEach((row) => {
        const star = parseInt(row.dataset.distStar, 10);
        const count = byStar[star] || 0;
        const pct = allReviews.length ? (count / allReviews.length) * 100 : 0;
        row.querySelector('[data-dist-fill]').style.width = `${pct}%`;
        row.querySelector('[data-dist-count]').textContent = count;
        row.classList.toggle('is-active', filterStar === star);
        row.setAttribute('aria-pressed', filterStar === star ? 'true' : 'false');
      });
    }
  }

  function reviewHtml(r) {
    const photos = Array.isArray(r.photos) && r.photos.length
      ? `<div class="ccs-review__photos">${r.photos.map((p) =>
          `<img src="${STORAGE_URL}${esc(p)}" alt="Customer photo" loading="lazy">`
        ).join('')}</div>`
      : '';
    const date = r.created_at
      ? new Date(r.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
      : '';
    const location = r.customer_location
      ? `<span class="ccs-review__location">${esc(r.customer_location)}</span>`
      : '';
    return `
      <div class="ccs-review">
        <div class="ccs-review__top">
          <div class="ccs-review__stars">${stars(r.rating)}</div>
          <span class="ccs-review__author">${esc(r.author)}</span>
          ${location}
          <span class="ccs-review__date">${esc(date)}</span>
          ${r.verified ? '<span class="ccs-review__verified">✓ Verified Purchase</span>' : ''}
        </div>
        ${r.title ? `<p class="ccs-review__title">${esc(r.title)}</p>` : ''}
        <p class="ccs-review__body">${esc(r.body)}</p>
        ${photos}
      </div>`;
  }

  function hasPhotos(r) {
    return Array.isArray(r.photos) && r.photos.length > 0;
  }

  // Reviews with photos are more persuasive — surface them first, but keep
  // each group (with/without photos) in the existing created_at.desc order.
  function sortReviews(reviews) {
    const withPhotos = reviews.filter(hasPhotos);
    const withoutPhotos = reviews.filter((r) => !hasPhotos(r));
    return withPhotos.concat(withoutPhotos);
  }

  function renderPager(totalPages) {
    const pager = document.getElementById('ccs-pager');
    if (!pager) return;

    if (totalPages <= 1) {
      pager.hidden = true;
      pager.innerHTML = '';
      return;
    }

    pager.hidden = false;

    const pages = [1];
    const NEIGHBORS = 1;
    if (currentPage - NEIGHBORS > 2) pages.push('...');
    for (let p = Math.max(2, currentPage - NEIGHBORS); p <= Math.min(totalPages - 1, currentPage + NEIGHBORS); p++) {
      pages.push(p);
    }
    if (currentPage + NEIGHBORS < totalPages - 1) pages.push('...');
    if (totalPages > 1) pages.push(totalPages);

    const numbersHtml = pages
      .map((p) => (p === '...'
        ? '<span class="ccs-pager__ellipsis">…</span>'
        : `<button type="button" class="ccs-pager__btn${p === currentPage ? ' is-active' : ''}" data-page="${p}"${p === currentPage ? ' aria-current="page"' : ''}>${p}</button>`))
      .join('');

    pager.innerHTML = `
      <button type="button" class="ccs-pager__nav" data-page="${currentPage - 1}" aria-label="Previous page"${currentPage === 1 ? ' disabled' : ''}>‹</button>
      ${numbersHtml}
      <button type="button" class="ccs-pager__nav" data-page="${currentPage + 1}" aria-label="Next page"${currentPage === totalPages ? ' disabled' : ''}>›</button>
    `;

    pager.querySelectorAll('[data-page]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = parseInt(btn.dataset.page, 10);
        if (target < 1 || target > totalPages || target === currentPage) return;
        currentPage = target;
        renderList();
        document.getElementById('ccs-list').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function renderList() {
    const list = document.getElementById('ccs-list');
    const pager = document.getElementById('ccs-pager');
    if (!list) return;

    if (loadFailed) {
      list.innerHTML = '<p class="ccs-empty">Couldn’t load reviews right now. Please refresh the page.</p>';
      if (pager) pager.hidden = true;
      return;
    }

    if (!allReviews.length) {
      // Empty state is already communicated by the compact header line above;
      // avoid repeating the same message here.
      list.innerHTML = '';
      if (pager) pager.hidden = true;
      return;
    }

    const base = filterStar
      ? allReviews.filter((r) => r.rating === filterStar)
      : allReviews;

    if (!base.length) {
      list.innerHTML = '<p class="ccs-empty">No reviews with this rating.</p>';
      if (pager) pager.hidden = true;
      return;
    }

    const filtered = sortReviews(base);
    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    if (currentPage > totalPages) currentPage = totalPages;

    const start = (currentPage - 1) * PAGE_SIZE;
    const visible = filtered.slice(start, start + PAGE_SIZE);
    list.innerHTML = visible.map(reviewHtml).join('');
    renderPager(totalPages);

    list.querySelectorAll('.ccs-review__photos img').forEach((img) => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => {
        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:99999;display:flex;align-items:center;justify-content:center;cursor:zoom-out';
        const big = document.createElement('img');
        big.src = img.src;
        big.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:4px';
        overlay.appendChild(big);
        overlay.addEventListener('click', () => overlay.remove());
        document.body.appendChild(overlay);
      });
    });
  }

  async function loadReviews() {
    try {
      const data = await api('GET', `reviews?product_id=eq.${productId}&approved=eq.true&order=created_at.desc`);
      allReviews = Array.isArray(data) ? data : [];
    } catch (e) {
      loadFailed = true;
    }
    renderSummary();
    renderList();
  }

  // Load and render reviews FIRST, so that displaying reviews never depends on
  // the optional form/picker UI bindings below existing. If the served section
  // markup and this script ever fall out of sync (e.g. mixed browser cache),
  // reviews still render instead of the whole block getting stuck on "Loading".
  loadReviews();

  // Everything below is optional UI wiring. Each binding is null-guarded so a
  // single missing element can never throw and block review rendering.
  function on(id, event, handler) {
    const el = document.getElementById(id);
    if (el) el.addEventListener(event, handler);
    return el;
  }

  try {
    // Distribution rows filter the list by star rating (toggle).
    document.querySelectorAll('.ccs-dist__row').forEach((row) => {
      row.addEventListener('click', () => {
        const star = parseInt(row.dataset.distStar, 10);
        filterStar = filterStar === star ? 0 : star;
        currentPage = 1;
        renderSummary();
        renderList();
      });
    });

    // Star picker
    const picker = document.getElementById('ccs-star-picker');
    if (picker) {
      picker.querySelectorAll('span').forEach((s) => {
        s.addEventListener('mouseover', () => {
          picker.querySelectorAll('span').forEach((x, i) =>
            x.classList.toggle('active', i < parseInt(s.dataset.val, 10)));
        });
        s.addEventListener('click', () => {
          selectedRating = parseInt(s.dataset.val, 10);
          picker.querySelectorAll('span').forEach((x, i) =>
            x.classList.toggle('selected', i < selectedRating));
        });
      });
      picker.addEventListener('mouseleave', () => {
        picker.querySelectorAll('span').forEach((x, i) =>
          x.classList.toggle('active', i < selectedRating));
      });
    }

    // Toggle form
    on('ccs-toggle-form', 'click', () => {
      const wrap = document.getElementById('ccs-form-wrap');
      if (wrap) wrap.style.display = 'block';
    });
    on('ccs-cancel', 'click', () => {
      const wrap = document.getElementById('ccs-form-wrap');
      if (wrap) wrap.style.display = 'none';
    });

    // Submit
    on('ccs-submit', 'click', async () => {
      const author = document.getElementById('ccs-author').value.trim();
      const location = document.getElementById('ccs-location').value.trim();
      const title = document.getElementById('ccs-title').value.trim();
      const body = document.getElementById('ccs-body').value.trim();
      const files = document.getElementById('ccs-photos').files;
      const msg = document.getElementById('ccs-msg');

      if (!author || !selectedRating || !body) {
        msg.textContent = 'Please fill in your name, rating, and review.';
        msg.style.display = 'block';
        msg.className = 'ccs-msg ccs-msg--error';
        return;
      }

      const btn = document.getElementById('ccs-submit');
      btn.textContent = 'Submitting...';
      btn.disabled = true;

      try {
        const photos = [];
        const maxFiles = Math.min(files.length, 3);
        for (let i = 0; i < maxFiles; i++) {
          if (files[i].size > 5 * 1024 * 1024) continue;
          const name = await uploadPhoto(files[i]);
          photos.push(name);
        }

        const payload = {
          product_id: productId,
          author,
          title,
          body,
          rating: selectedRating,
          photos,
          source: 'organic',
          // RLS insert policy only allows pending, unverified submissions.
          approved: false,
          verified: false
        };
        if (location) payload.customer_location = location;

        let res = await api('POST', 'reviews', payload);
        if (!res.ok && location) {
          // Older schema without the optional location column: retry without it.
          delete payload.customer_location;
          res = await api('POST', 'reviews', payload);
        }
        if (!res.ok) throw new Error(`Review submit failed (${res.status})`);

        msg.textContent = 'Thank you! Your review will appear after approval.';
        msg.className = 'ccs-msg ccs-msg--success';

        document.getElementById('ccs-author').value = '';
        document.getElementById('ccs-location').value = '';
        document.getElementById('ccs-title').value = '';
        document.getElementById('ccs-body').value = '';
        document.getElementById('ccs-photos').value = '';
        selectedRating = 0;
        if (picker) picker.querySelectorAll('span').forEach((x) => x.classList.remove('selected', 'active'));
      } catch (e) {
        msg.textContent = 'Sorry, something went wrong submitting your review. Please try again.';
        msg.className = 'ccs-msg ccs-msg--error';
      } finally {
        msg.style.display = 'block';
        btn.textContent = 'Submit Review';
        btn.disabled = false;
      }
    });
  } catch (e) {
    // Optional UI wiring failed — reviews themselves already loaded above.
  }
})();
